<template>
  <div>
    <section class="hero is-primary">
      <div class="container">
        <nav
          class="breadcrumb is-small"
          aria-label="breadcrumbs"
        >
          <ul>
            <li>
              <router-link :to="{ name: 'home' }">
                Home
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'songs' }">
                Songs
              </router-link>
            </li>
            <li class="is-active">
              <a
                href="#"
                aria-current="page"
              >{{ song.title || "New" }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <song-edit
          :initial-song="song"
          @update="updateSelectedSong($event)"
        />
      </div>
    </section>
    <a
      class="add button is-large is-warning"
      @click="save()"
    >
      <span class="icon is-medium">
        <i class="fas fa-check" />
      </span>
    </a>
  </div>
</template>

<script>
import SongEdit from "../components/SongEdit";
import { mapActions } from "vuex";

export default {
  components: {
    SongEdit
  },
  data() {
    return {
      song: {
        song: {
          composer: {},
          tags: []
        },
        title: "",
        lyrics: "",
        translator: {}
      }
    };
  },
  mounted() {
    this.clearSong();
  },
  methods: {
    save() {
      this.createSong().then(() => {
        this.$router.push("/");
      });
    },
    ...mapActions(["updateSelectedSong", "createSong", "clearSong"])
  }
};
</script>

<style lang="scss">
.save {
  @include action-button();
}
</style>



// WEBPACK FOOTER //
// NewSong.vue?7773c81f